import { Toast } from 'vant'

export function handleJumpToDkgdh (appUrl) {
  if (appUrl) {
    // 如果是广东红首页，使用switchTab
    const api = ['/pages/index/index', '/pages/find/index', '/pages/photo/index', '/pages/answer/index', '/pages/mine/index'].includes(appUrl)
      ? window.wx.miniProgram.switchTab
      : window.wx.miniProgram.navigateTo
    api({
      url: appUrl,
      fail: () => {
        Toast('请在微信中打开此链接')
      },
    })
  } else {
    window.wx.miniProgram.switchTab({
      url: '/pages/find/index',
      fail: () => {
        Toast('请在微信中打开此链接')
      },
    })
  }
}
